module.exports = __webpack_public_path__ + "img/1440.c3a997a5.jpg";